module.exports = __webpack_public_path__ + "img/image01_sp.205f8b73.jpg";